// Static project + asset data for Feenstra Designs

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_67f126b7-e9c3-4736-87b1-5ffe4f2595a7/artifacts/gfqkkb14_image.png",
  portrait: "https://customer-assets-rejwkqb3.emergentagent.net/job_feenstra-viz/artifacts/ef1msb5e_c710e792-f7e9-4cb5-a3bf-c31eacb36776.png",
  // HERO — Rijtjesvilla with hammock at dusk
  hero: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/6o73boyh_ChatGPT%20Image%2023%20jun%202026%2C%2010_40_39.png",
  // Originals
  woodenPavilion: "https://customer-assets.emergentagent.com/job_67f126b7-e9c3-4736-87b1-5ffe4f2595a7/artifacts/u57awime_image.png",
  publicQuarter: "https://customer-assets.emergentagent.com/job_67f126b7-e9c3-4736-87b1-5ffe4f2595a7/artifacts/wqpkravp_image.png",
  aFrameGreen: "https://customer-assets.emergentagent.com/job_67f126b7-e9c3-4736-87b1-5ffe4f2595a7/artifacts/fj1ek7en_image.png",
  luxuryVilla: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/bra76leh_9350d7ea-2cad-414e-a01a-4f7faa019cb3.png",
  solarExtension: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/43h6vf1r_WhatsApp%20Image%202026-05-10%20at%2015.47.40.jpeg",
  playground: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/j95an1mz_0435f7d9-5a24-49e8-a7fb-5095fbdfb7c3.png",
  // Tuinpaviljoen — garden studio (4 angles)
  gardenStudio1: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/ttxpp5rm_final%20render%20tuinhokje.png",
  gardenStudio2: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/1umqexlc_final%20render%20tuinhokje%202.png",
  gardenStudio3: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/lrrec3zq_final%20render%20tuinhokje%203.png",
  gardenStudio4: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/p2nb3cir_final%20render%20tuinhokje%204.png",
  // Verticale Houten Studio — NEW improved render (replaces old)
  verticalStudio: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/6tcof31e_3064edb9-1749-4eb7-b912-4b8470caa64d.png",
  // Moderne Donkere Stadswoning — NEW project (4 views)
  darkHouseExterior: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/u23p0v0d_5592ac5b-5d0b-4a0f-870f-e9270c1fbd31.png",
  darkHouseKitchen: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/ln6k4a45_bb46759b-94c6-4890-98c5-1dfc7869096c.png",
  darkHousePavilion: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/mxj3cyf1_2a4e044f-1fbf-45da-9525-4402e8394490.png",
  darkHouseCarport: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/rrzlxloe_9ba8e684-c8e8-4755-be55-3cb4481f92eb.png",
  // Moderne Rijtjesvilla — NEW project (3 exterior + 2 interior + overview)
  terracedOverview: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/xn70pomh_overall%20render.jpeg",
  terracedExt1: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/6o73boyh_ChatGPT%20Image%2023%20jun%202026%2C%2010_40_39.png",
  terracedExt2: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/xkym30lh_ChatGPT%20Image%2023%20jun%202026%2C%2010_41_19.png",
  terracedExt3: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/3w42twuu_ChatGPT%20Image%2023%20jun%202026%2C%2010_45_05.png",
  terracedInt1: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/sgmiefjo_ChatGPT%20Image%2023%20jun%202026%2C%2011_57_42.png",
  terracedInt2: "https://customer-assets.emergentagent.com/job_feenstra-viz/artifacts/fhozil7i_ChatGPT%20Image%2023%20jun%202026%2C%2012_01_10.png",
};

// Category folders for the portfolio filter
export const CATEGORIES = [
  { id: "all", label: { nl: "Alle", en: "All" } },
  { id: "woningen", label: { nl: "Woningen", en: "Homes" } },
  { id: "villas", label: { nl: "Villa's", en: "Villas" } },
  { id: "interieur", label: { nl: "Interieur", en: "Interior" } },
  { id: "duurzaam", label: { nl: "Duurzame Woningen", en: "Sustainable" } },
  { id: "verbouwingen", label: { nl: "Verbouwingen", en: "Renovations" } },
  { id: "gebied", label: { nl: "Gebiedsontwikkeling", en: "Urban Design" } },
  { id: "tuin", label: { nl: "Tuinarchitectuur", en: "Garden Architecture" } },
];

// PROJECTS as folders: each contains cover (best preview) + full images array
export const PROJECTS = [
  {
    id: "luxe-villa-zwembad",
    title: { nl: "Luxe Villa met Zwembad", en: "Luxury Villa with Pool" },
    category: "villas",
    summary: {
      nl: "Hoogwaardige avondrender van een moderne villa met privézwembad.",
      en: "High-end twilight render of a modern villa with private pool.",
    },
    cover: ASSETS.luxuryVilla,
    images: [ASSETS.luxuryVilla],
  },
  {
    id: "moderne-donkere-stadswoning",
    title: { nl: "Moderne Donkere Stadswoning", en: "Modern Dark Townhouse" },
    category: "woningen",
    summary: {
      nl: "Een tweelaagse stadswoning met zwarte bakstenen gevel, carport en sfeervolle binnenruimtes.",
      en: "Two-storey townhouse with black brick façade, carport and atmospheric interiors.",
    },
    cover: ASSETS.darkHouseExterior,
    images: [
      ASSETS.darkHouseExterior,
      ASSETS.darkHousePavilion,
      ASSETS.darkHouseCarport,
      ASSETS.darkHouseKitchen,
    ],
  },
  {
    id: "moderne-rijtjesvilla",
    title: { nl: "Moderne Rijtjesvilla", en: "Modern Terraced Villa" },
    category: "woningen",
    summary: {
      nl: "Rij van A-frame villa's met hoge glaspartijen, warme avondsfeer en verzorgde binnentuinen.",
      en: "A row of A-frame villas with tall glass façades, warm evening atmosphere and refined interior courtyards.",
    },
    cover: ASSETS.terracedOverview,
    images: [
      ASSETS.terracedOverview,
      ASSETS.terracedExt1,
      ASSETS.terracedExt2,
      ASSETS.terracedExt3,
      ASSETS.terracedInt1,
      ASSETS.terracedInt2,
    ],
  },
  {
    id: "rijtjesvilla-interieur",
    title: { nl: "Rijtjesvilla — Interieur", en: "Terraced Villa — Interior" },
    category: "interieur",
    summary: {
      nl: "Interieurstudies van de rijtjesvilla — keuken met watervergezicht en warme leefruimte in avondlicht.",
      en: "Interior studies of the terraced villa — kitchen with water view and warm living space in evening light.",
    },
    cover: ASSETS.terracedInt1,
    images: [ASSETS.terracedInt1, ASSETS.terracedInt2],
  },
  {
    id: "houten-paviljoen",
    title: { nl: "Houten Paviljoen", en: "Wooden Pavilion" },
    category: "woningen",
    summary: {
      nl: "Sfeervol houten paviljoen met gebogen glaspartij in avondlicht.",
      en: "Atmospheric wooden pavilion with curved glass façade at twilight.",
    },
    cover: ASSETS.woodenPavilion,
    images: [ASSETS.woodenPavilion],
  },
  {
    id: "groene-architectuur",
    title: { nl: "Groene A-Frame Woning", en: "Green A-Frame Residence" },
    category: "duurzaam",
    summary: {
      nl: "Duurzame A-frame woning met begroeid dak, gesitueerd in een natuurlijk landschap.",
      en: "Sustainable A-frame home with living roof, set in a natural landscape.",
    },
    cover: ASSETS.aFrameGreen,
    images: [ASSETS.aFrameGreen],
  },
  {
    id: "uitbouw-zonnepanelen",
    title: { nl: "Uitbouw met Zonnepanelen", en: "Sustainable Extension" },
    category: "verbouwingen",
    summary: {
      nl: "Aanbouw aan bestaande woning, gecombineerd met geïntegreerde zonnepanelen.",
      en: "Extension of existing home, combined with integrated solar panels.",
    },
    cover: ASSETS.solarExtension,
    images: [ASSETS.solarExtension],
  },
  {
    id: "publieke-leefomgeving",
    title: { nl: "Publieke Leefomgeving", en: "Public Living Quarter" },
    category: "gebied",
    summary: {
      nl: "Wijkontwerp met groene routes, hagen en sociale ontmoetingsplaatsen.",
      en: "Neighbourhood design with green routes, hedges and social spaces.",
    },
    cover: ASSETS.publicQuarter,
    images: [ASSETS.publicQuarter],
  },
  {
    id: "buurtspeelplaats",
    title: { nl: "Buurtspeelplaats", en: "Neighbourhood Playground" },
    category: "gebied",
    summary: {
      nl: "Speelplek voor families met groene afscheiding, integratie in een nieuwbouwwijk.",
      en: "Family playground with green boundary, integrated into a residential development.",
    },
    cover: ASSETS.playground,
    images: [ASSETS.playground],
  },
  {
    id: "tuinpaviljoen",
    title: { nl: "Tuinpaviljoen", en: "Garden Pavilion" },
    category: "tuin",
    summary: {
      nl: "Glaspaviljoen met sedumdak in vier ambiances: dag, achterzijde, avond en schemering.",
      en: "Glass pavilion with sedum roof in four moods: day, rear view, evening and dusk.",
    },
    cover: ASSETS.gardenStudio1,
    images: [
      ASSETS.gardenStudio1,
      ASSETS.gardenStudio2,
      ASSETS.gardenStudio3,
      ASSETS.gardenStudio4,
    ],
  },
];

// Helper: flatten all images for global lightbox usage if needed
export const PROJECT_BY_ID = Object.fromEntries(
  PROJECTS.map((p) => [p.id, p])
);
